module.exports = __webpack_public_path__ + "static/media/PRACTICA1.f35d2eed.jpg";